import { render, staticRenderFns } from "./DogBowl.vue?vue&type=template&id=e85cd48c&"
import script from "./DogBowl.vue?vue&type=script&lang=js&"
export * from "./DogBowl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e85cd48c')) {
      api.createRecord('e85cd48c', component.options)
    } else {
      api.reload('e85cd48c', component.options)
    }
    module.hot.accept("./DogBowl.vue?vue&type=template&id=e85cd48c&", function () {
      api.rerender('e85cd48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Illustrations/DogBowl.vue"
export default component.exports